import { render, staticRenderFns } from "./jsweb.vue?vue&type=template&id=1b98b012&scoped=true&"
import script from "./jsweb.vue?vue&type=script&lang=js&"
export * from "./jsweb.vue?vue&type=script&lang=js&"
import style0 from "./jsweb.vue?vue&type=style&index=0&id=1b98b012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98b012",
  null
  
)

export default component.exports